/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { Accordion } from "@components/anti/Accordion"
import Select from "@components/anti/Forms/components/select"
import TableCinema from "@components/global/TableCinema"
import InvestorsAreaGovernanceLayout from "@components/pages/investors-area-governance/investors-area-governance-layout"
import { fetchAPI, getPageBySlug } from "lib/api"
import { Q_POST_YEAR_LIST } from "lib/query"
import { linkInvestorProspectus } from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { convertJson, extractMeta } from "src/mixins"

function IrActivitiesPage({ locale, data, yearList }) {
  const Router = useRouter()

  const [expanded, setExpanded] = useState(0)
  const [state, setState] = useState({
    year: {
      label: translations[`all_year_${locale}`],
      value: 0,
    },
    list: [],
    yearOptions: [],
  })
  const handleChangeYear = async (year) => {
    if (+year === 0 || !year) {
      setState((prev) => ({
        ...prev,
        year: { label: translations[`all_year_${locale}`], value: 0 },
      }))
    } else {
      setState((prev) => ({ ...prev, year: { label: +year, value: +year } }))
    }
  }
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  useEffect(() => {
    const activities = extractMeta(data?.meta, "activities")
    const listActivities = convertJson(activities.items)
    if (!Router.query.year) {
      setState((prev) => ({ ...prev, list: listActivities }))
    } else {
      const result = listActivities?.find(
        (item) => +item.year === state.year.value
      )
      setState((prev) => ({ ...prev, list: result }))
    }
  }, [data, state.year])
  useEffect(() => {
    const allyear = { label: translations[`all_year_${locale}`], value: 0 }
    const list = yearList?.map((item) => ({
      label: item,
      value: item,
    }))
    list?.unshift(allyear)
    setState((prev) => ({
      ...prev,
      year: allyear,
      yearOptions: list,
    }))
  }, [locale])
  useEffect(() => {
    handleChangeYear(Router.query?.year)
  }, [Router.query])

  return (
    <>
      <InvestorsAreaGovernanceLayout
        pageName="ir-activities"
        coverTitle={data[`title_${locale}`]}
        breadcrumb={[
          {
            title: translations[`investors_area_${locale}`],
            url: linkInvestorProspectus,
          },
          { title: translations[`ir_activities_${locale}`] },
        ]}
        type="investor"
      >
        <Select
          className="field__select-year"
          floatingLabel
          variant="underline"
          label={translations[`year_${locale}`]}
          options={state.yearOptions}
          value={state.year}
          onChange={(_, val) => {
            if (val.value === 0) {
              const { slug, year, ...query } = Router.query
              Router.push(
                {
                  pathname: Router.asPath?.split("?")[0],
                  query: { ...query },
                },
                null,
                {
                  scroll: false,
                }
              )
            } else {
              const { slug, ...query } = Router.query
              Router.push(
                {
                  pathname: Router.asPath?.split("?")[0],
                  query: { ...query, year: val.value },
                },
                null,
                { scroll: false }
              )
            }
          }}
        />
        {state.year.value === 0 && state?.list?.length ? (
          state?.list?.map((item, i) => (
            <Accordion
              variant="line"
              title={item.year}
              key={`ir-activities__accordion-${i}`}
              expandedKey={i}
              expanded={expanded === i}
              onChange={handleChange(i)}
            >
              <div className="overflow-auto">
                <TableCinema
                  id="ir-activities__table"
                  className="ir-activities__table"
                  headerClassName="bold"
                  headers={[
                    { label: "No" },
                    { label: translations[`date_${locale}`] },
                    { label: translations[`host_${locale}`] },
                    { label: translations[`title_${locale}`] },
                    { label: translations[`location_${locale}`] },
                  ]}
                  data={item.items?.map((itemChild) => ({
                    ...itemChild,
                    date: itemChild.date
                      ? moment(itemChild.date).format("DD MMM YYYY")
                      : "-",
                  }))}
                />
              </div>
            </Accordion>
          ))
        ) : (
          <div className="overflow-auto">
            <TableCinema
              id="ir-activities__table"
              className="ir-activities__table"
              headerClassName="bold"
              headers={[
                { label: "No" },
                { label: translations[`date_${locale}`] },
                { label: translations[`host_${locale}`] },
                { label: translations[`title_${locale}`] },
                { label: translations[`location_${locale}`] },
              ]}
              data={state?.list?.items?.map((itemChild) => ({
                ...itemChild,
                date: moment(itemChild.date).format("DD MMM YYYY"),
              }))}
            />
          </div>
        )}
      </InvestorsAreaGovernanceLayout>
    </>
  )
}
export default IrActivitiesPage

export async function getStaticProps(ctx) {
  const { locale } = ctx
  const data = await getPageBySlug("ir-activities")
  const activities = extractMeta(data?.meta, "activities")
  const listActivities = convertJson(activities.items)
  const yearList = [...new Set(listActivities?.map((item) => `${item.year}`))]
  return {
    props: {
      seo: {
        title: data[`title_${locale}`] || "IR Activities",
      },
      page: "investors-area ir-activities",
      locale,
      data,
      yearList,
    },
    revalidate: 60,
  }
}
